
// Agree to Terms
//=========================================================
 $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        console.log("Checkout button clicked"); // Debugging line
        if ($('#agree').is(':checked')) {
            console.log("Checkbox is checked, proceeding...");
            $(this).submit();
        } else {
            console.log("Checkbox NOT checked, stopping checkout.");
            alert("You must verify you have read our Terms & Conditions.");
            return false;
        }
    });
});
